module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "p-collapse"
  }, [_c('div', {
    staticClass: "p-collapse-title",
    class: {
      expanded: _vm.isExpanded, clickable: !_vm.hasPromptSlots
    },
    on: {
      "click": function($event) {
        !_vm.hasPromptSlots && _vm.toggle()
      }
    }
  }, [_vm._t("title")], 2), _vm._v(" "), (_vm.hasPromptSlots) ? _c('div', {
    staticClass: "p-collapse-showmore p-clickable",
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }, [(_vm.isExpanded) ? _vm._t("showless") : _vm._t("showmore")], 2) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [(_vm.isExpanded) ? _c('div', {
    staticClass: "p-collapse-content"
  }, [_vm._t("content")], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-162fb618"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/collapse.vue
// module id = 29
// module chunks = 0